export const BadgeSignals = {
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  Info: 'info',
  Brand: 'brand',
  Neutral: 'neutral',
  NeutralInverse: 'neutral-inverse',
  Dot: 'dot',
  Number: 'number',
} as const;

export type TBadgeSignals = (typeof BadgeSignals)[keyof typeof BadgeSignals];
